module.exports = __webpack_public_path__ + "img/pensees1_md.c1939573.jpg";